import * as React from 'react';
import { Button, ButtonTypes } from './Button';

import { SizeEnum } from 'common/enums/UIEnums';
import { translate } from 'react-i18next';

class AddButton extends React.PureComponent {
    render() {
        const { onClick, t, label = `+ ${t('add')}`, ...others } = this.props;
        return <Button {...others} onClick={onClick} label={label} />;
    }
}

AddButton.defaultProps = {
    uppercase: true,
    inverted: true,
    semibold: true,
    size: SizeEnum.Small,
    buttonType: ButtonTypes.Flat,
    ripple: false
};

const EnhancedAddButton = translate()(AddButton);
export { EnhancedAddButton as AddButton };
export default EnhancedAddButton;
